// MJ_MANUAL_OFFER_V1: open only after an explicit click or that form's submitted response.
(() => {
  const popup = document.querySelector('[data-mj-welcome]');
  const triggers = [...document.querySelectorAll('[data-mj-welcome-open]')];
  if (!popup || !triggers.length || popup.dataset.mjBound === 'true') return;
  popup.dataset.mjBound = 'true';
  const dialog = popup.querySelector('[role="dialog"]');
  const form = popup.closest('form');
  const submittedKey = 'mj_welcome_manual_submit_v1';
  let previousFocus = null;
  const open = (trigger) => {
    if (!popup.hidden) return;
    previousFocus = trigger || document.activeElement;
    popup.hidden = false;
    triggers.forEach(el => { el.hidden = true; el.setAttribute('aria-expanded', 'true'); });
    document.body.classList.add('mj-welcome-open');
    // Focus the dialog, not the email field: do not raise the mobile keyboard before the user asks.
    dialog?.focus({preventScroll: true});
  };
  const close = () => {
    popup.hidden = true;
    triggers.forEach(el => { el.hidden = false; el.setAttribute('aria-expanded', 'false'); });
    document.body.classList.remove('mj-welcome-open');
    (previousFocus?.isConnected ? previousFocus : triggers[0])?.focus({preventScroll: true});
  };
  triggers.forEach(trigger => {
    trigger.hidden = false;
    trigger.addEventListener('click', event => { event.preventDefault(); open(trigger); });
    trigger.addEventListener('keydown', event => {
      if (event.key === ' ') { event.preventDefault(); open(trigger); }
    });
  });
  popup.querySelectorAll('[data-mj-welcome-close]').forEach(el => el.addEventListener('click', close));
  document.addEventListener('keydown', event => {
    if (popup.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),[tabindex="0"]')].filter(el => !el.hidden && el.getClientRects().length);
    const first = focusable[0], last = focusable.at(-1), active = document.activeElement;
    if (!first) { event.preventDefault(); dialog.focus(); return; }
    if (event.shiftKey && (active === first || active === dialog || !dialog.contains(active))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (active === last || active === dialog || !dialog.contains(active))) { event.preventDefault(); first.focus(); }
  });
  const codeButton = popup.querySelector('[data-mj-copy-code]');
  codeButton?.addEventListener('click', async () => {
    const label = codeButton.querySelector('[data-mj-copy-label]');
    try { await navigator.clipboard.writeText(codeButton.dataset.code || 'MJWELCOME10'); if (label) label.textContent = 'COPIED'; }
    catch (_) { if (label) label.textContent = 'MJWELCOME10'; }
  });
  // Preserve the result of this explicitly submitted form, not a general visitor/open state.
  form?.addEventListener('submit', () => {
    if (!popup.hidden) { try { sessionStorage.setItem(submittedKey, String(Date.now())); } catch (_) {} }
  });
  let submittedAt = 0;
  try { submittedAt = Number(sessionStorage.getItem(submittedKey) || 0); sessionStorage.removeItem(submittedKey); } catch (_) {}
  const isRecentSubmission = submittedAt > 0 && Date.now() >= submittedAt && Date.now() - submittedAt < 10 * 60 * 1000;
  if (isRecentSubmission && (popup.dataset.success === 'true' || popup.dataset.error === 'true')) open(triggers[0]);
  // Deliberately no timed, scroll, exit-intent, stored-dismissal, or viewport-dependent opening.
})();
